<template>
  <div id="Register" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white bb1 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>rea tu cuenta</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12">
      <div class="col-12 f14 pl10 pr10 bg-color-white pt10 pb10">
        <div class="col-12 mb10">
          <div class="col-12 t-l color-muted lh32">Usuario</div>
          <div class="col-12"><input type="text" name="" v-model="pageData.user" class="col-12 lh36 pl5 pr5 b1"></div>
        </div>
        <div class="col-12 mb10">
          <div class="col-12 t-l color-muted lh32">Nombre</div>
          <div class="col-12"><input type="text" name="" v-model="pageData.name" class="col-12 lh36 pl5 pr5 b1"></div>
        </div>
        <div class="col-12 mb10">
          <div class="col-12 t-l color-muted lh32">Email</div>
          <div class="col-12"><input type="text" name="" v-model="pageData.email" class="col-12 lh36 pl5 pr5 b1"></div>
        </div>
        <div class="col-12 mb10">
          <div class="col-12 t-l color-muted lh32">Clave</div>
          <div class="col-12"><input type="text" name="" v-model="pageData.password" class="col-12 lh36 pl5 pr5 b1"></div>
        </div>
      </div>
      <div class="col-12 mb10 mt10 pl10 pr10">
        <button class="bg-color-primary color-white w-100 lh40" @click="reg()">Registro</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Register',
  data () {
    return {
      pageData: {
        user: '',
        name: '',
        email: '',
        password: ''
      }
    }
  },
  created: function () {
    //this.get_pageData();
    
  },
  methods: {
    reg: function () {
      if(this.pageData.user == ''){
        this.$store.commit('setAlert',{type:'error',msg: "Usuario no puede estar vacío"});
        return;
      }
      if(this.pageData.name.length < 5){
        this.$store.commit('setAlert',{type:'error',msg: "Nombre debe tener al menos 5 caracteres"});
        return;
      }
      if(this.pageData.name == ''){
        this.$store.commit('setAlert',{type:'error',msg: "Nombre no puede estar vacío"});
        return;
      }
      if(this.pageData.email == ''){
        this.$store.commit('setAlert',{type:'error',msg: "Email no puede estar vacío"});
        return;
      }
      if(this.pageData.password == ''){
        this.$store.commit('setAlert',{type:'error',msg: "Clave no puede estar vacío"});
        return;
      }
      if(this.pageData.password.length < 6){
        this.$store.commit('setAlert',{type:'error',msg: "Clave debe tener al menos 6 caracteres"});
        return;
      }
      var post_data = this.pageData;
      this.post(this.api_url + 'pub/register', post_data).then((res)=>{
        if(res.status == 1){
          this.$router.push({ path: 'Login' })
        }else{
          this.$store.commit('setAlert',res.msg);
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/My/Register.vue